import { Tag } from 'antd';
export default {
	JobTypes: { FULL_TIME: 'Full Time', PART_TIME: 'Part Time', REMOTE: 'Remote' },
	CareerLevels: {
		STUDENT: 'Student',
		ENTRY_LEVEL: 'Entry Level',
		JUNIOR: 'Junior',
		MIDLEVEL: 'Mid-Level',
		SENIOR: 'Senior',
		TEAM_LEAD: 'Team Lead',
		MANAGER: 'Manager'
	},
	Currencies: { EGP: 'EGP', USD: 'USD', EUR: 'EUR' },
	ProficiencyLevels: {
		BASICS: 'Basics',
		FAMILIARITY: 'Familiarity',
		GOOD_KNOWLEDGE: 'Good Knowledge',
		VERY_GOOD: 'Very Good',
		EXCELLENT: 'Excellent'
	},
	AssessmentMethods: [
		{
			id: 'Phone',
			key: 'Phone',
			filteringMethod: 'Phone Screening',
			time: { min: 2, max: 4 },
			price: 0,
			tag: <Tag>Fastest</Tag>
		},
		{
			id: 'Default',
			key: 'Default',
			filteringMethod: 'Talents Arena Assessment',
			time: { min: 5, max: 10 },
			price: 0
		}
		// {
		// 	id: 'Custom',
		// 	key: 'Custom',
		// 	filteringMethod: 'Custom Assessment',
		// 	time: { min: 5, max: 10 },
		// 	price: 20,
		// 	tag: <Tag color="#87d068">Recommended</Tag>
		// }
	]
};
